import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
const ClickHandler = () => {
  window.scrollTo(10, 0);
};

const TeamSection = (props) => {
  const [teamData, setTeamData] = useState([]);
  useEffect(() => {
    const getTeamData = async () => {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/team`);
      const data = await response.json();
      setTeamData(data.data);
    };
    getTeamData();
  }, []);
  return (
    <section className="wpo-team-section section-padding">
      <div className="container">
        <div className="row align-items-center justify-content-center">
          <div className="col-lg-5" style={{ width: "100%" }}>
            <div>
              <h2
                style={{
                  width: "100%",
                  textAlign: "center",
                  fontSize: "3rem",
                  fontWeight: "bold",
                  color: "white",
                }}
              >
                Expert Cleaners
              </h2>
              <p style={{ color: "white" }}>
                Our certified team of cleaning professionals brings experience,
                precision, and dedication to every project. Each member is
                trained to deliver spotless results and exceptional service,
                ensuring your home or office always looks its best. Meet the
                experts behind Elite Spark—your trusted partners in cleanliness.
                .
              </p>
            </div>
          </div>
        </div>
        <div className="wpo-team-wrap">
          <div className="row">
            {teamData?.length > 0 ? (
              teamData?.map((team, aitem) => (
                <div className="col col-lg-6 col-md-12 col-12" key={aitem}>
                  <div className="wpo-team-item">
                    <div className="wpo-team-img">
                      <img src={team.image} alt="" />
                    </div>
                    <div className="wpo-team-text">
                      <span>{team.role}</span>
                      <h2>{team.fullName}</h2>
                      <div className="social">
                        <ul>
                          {team?.facebookLink && (
                            <li>
                              <a href={team?.facebookLink}>
                                <i className="ti-facebook"></i>
                              </a>
                            </li>
                          )}
                          {team?.twitterLink && (
                            <li>
                              <a href={team?.twitterLink}>
                                <i className="ti-twitter-alt"></i>
                              </a>
                            </li>
                          )}
                          {team?.linkedInLink && (
                            <li>
                              <a href={team?.linkedInLink}>
                                <i className="ti-linkedin"></i>
                              </a>
                            </li>
                          )}
                          {team?.instagramLink && (
                            <li>
                              <a href={team?.instagramLink}>
                                <i className="ti-instagram"></i>
                              </a>
                            </li>
                          )}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div
                className="p-4 text-center "
                style={{
                  fontSize: "2rem",
                  fontWeight: "bold",
                  color: "white",
                }}
              >
                No Team Found
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
